export default __webpack_public_path__ + "static/media/MAM-900x600-Likuliku-Overwater-hero.fca65f21.jpg";